import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { validateAccessModule } from '../../../../../utils/helpers.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../../utils/rbac-constants.utils';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { MODAL_CUSTOM_MESSAGE, Selected_Index, TABLE_PAGINATION_KEY } from '../../../../../constants/external-constants';
import { RequestHeaders } from '../../../../common/header-logo/request-header.component';
import { DetailsDashboard } from '../../../../common/details-dashboard/details-dashboard-layout';
import { TablePagination } from '../../../../common/details-table/table-pagination.component';
import { NoSubscription } from '../../../dashboard/no-subscription/no-subscription.component';
import { DetailsLayout } from '../../../../common/Layout/details';
import { billingAccountActions } from '../../../../../store/external/finance/billing-account.reducer';
import BillingAccountDetailsComponent from '../billing-account-form/billing-account-details/billing-account-details.component';
import BillingComment from '../billing-account-form/billing-comment/billing-comment.component';
import BillingHistory from '../billing-account-form/billing-history/billing-history.component';

class BillingAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            activeTab: Selected_Index.i_Zero,
            contentIndex: Selected_Index.i_Zero,
            viewDetailPage: false,
            showCreateNewConfirmationModal: false,
            headerTitle: "BillingAccount",
            billingAccountId: 0,
            isDataLoaded: false,
            selectedIndex: Selected_Index.i_Zero,
            createNew: false,
            selectedTab: 0,
            selectedBillingAccount: undefined,
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false,
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Comments",
                    "hidden": false,
                    "disable": true
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "History",
                    "hidden": false,
                    "disable": true
                }
            ],
        }
    }

    componentDidMount() {
        this.props.getBillingAccount();
        this.changeHeaderTitle();
    }

    componentWillUnmount() {
        this.props.setDefaultBillingAccount();
        this.props.getBillingAccount(0, true);
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractBillingAccount();
        }
    };

    renderTabContent = (index) => {
        this.setState({ selectedTab: index });
    }

    loadingScreen = () => {
        return (
            <NoSubscription />
        );
    }

    handleDisplaySearch = () => {
        this.setState(prev => ({
            displaySearch: !prev.displaySearch
        }));
    }

    resizePage = (value) => {
        const { getBillingAccount, resizeBillingAccountPage } = this.props;
        resizeBillingAccountPage(value);
        getBillingAccount();
    }

    applyFilter = (isApply, isReset = false) => {
        const { getBillingAccount, applyBillingAccountFilter } = this.props;
        applyBillingAccountFilter(isApply);
        (isApply || isReset) && getBillingAccount();
    }


    closeForm = () => {
        this.setState({
            billingAccountId: 0,
            viewDetailPage: false,
            createNew: false,
            selectedTab: Selected_Index.i_Zero
        }, () => (
            this.changeHeaderTitle()
        ));
    }

    handleCreateNew(buttonType) {
        if (buttonType === "ok") {
            this.setState({
                viewDetailPage: true,
                createNew: !this.state.createNew,
                showCreateNewConfirmationModal: false
            },
                () => {
                    const currentViewDetailPage = this.state.viewDetailPage;
                    this.changeHeaderTitle(currentViewDetailPage)
                });
        } else {
            this.setState({ showCreateNewConfirmationModal: false })
        }
    }

    handleCreateNewAction = () => {
        this.setState({
            showCreateNewConfirmationModal: true,
            billingAccountId: 0
        })
        this.changeHeaderTitle();
    }

    handleRowClick = () => {
        this.setState(
            { viewDetailPage: true },
            () => {
                const currentViewDetailPage = this.state.viewDetailPage;
                this.changeHeaderTitle(currentViewDetailPage);
            }
        );
    };

    getData = (isShow, rowItem) => {

        if (rowItem != null) {
            this.setState({
                viewDetailPage: isShow
                , billingAccountId: rowItem.FinanceAccountID
                , selectedBillingAccount: rowItem
            })

            this.setState({ viewDetailPage: isShow }, () => (
                this.changeHeaderTitle()
            ))
        }
        else {
            this.setState({ viewDetailPage: isShow }, this.changeHeaderTitle);
        }

    }

    changeHeaderTitle = () => {
        if (this.state.viewDetailPage) {
            this.setState({ headerTitle: "BillingAccountDetails" })
        } else {
            this.setState({ headerTitle: "BillingAccount" })
        }
    }

    handleCreateNewAction = () => {
        this.setState({
            showCreateNewConfirmationModal: true,
            billingAccountId: 0
        })
        this.changeHeaderTitle();

    }

    render() {

        const { billingAccount, getBillingAccount, setBillingAccountColSearchStr, sortBillingAccountList, saveBillingAccountCustomCols, addBillingAccountFilter, removeBillingAccountFilter } = this.props;
        const { headerTitle, billingAccountId, createNew } = this.state;
        const { Selected, Available, Default } = this.props.billingAccount?.billingAccountItems?.Columns || {};
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceBillingAccoungDashboardR]);
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceBillingAccoungDashboardRE]);
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceBillingAccoungDashboardRW]);


        return (
            <div className="invoice-wrapper-container inventory-report-component" >
                <ConfirmationNotificationModal
                    show={this.state.showCreateNewConfirmationModal}
                    message={MODAL_CUSTOM_MESSAGE.create_new_billing_account}
                    title={'Add New'}
                    handleModal={this.handleCreateNew.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                <RequestHeaders headerTitle={headerTitle} />
                <div className="request-table data-table fit-width">

                    {
                        this.state.viewDetailPage ?
                            <DetailsLayout
                                listTab={this.state.listTab}
                                handleClose={this.closeForm}
                                renderTabContent={this.renderTabContent}
                                urlIndex={this.state.selectedTab}
                                showBackButton={true}
                                customClass="data-form__container"
                                billingAccountId={this.state.billingAccountId}
                            >
                                {
                                    parseInt(this.state.selectedTab) === parseInt(Selected_Index.i_Zero) &&
                                    <BillingAccountDetailsComponent
                                        isCreateNew={createNew}
                                        handleCloseForm={this.closeForm}
                                        getBillingAccount={getBillingAccount}
                                        financeAccountId={this.state.billingAccountId}
                                        isReadOnly={isReadOnly}
                                        isReadAndExtractOnly={isReadAndExtractOnly}
                                        isReadAndWrite={isReadAndWrite}
                                        selectedBillingAccount={this.state.selectedBillingAccount}
                                    />
                                }
                                {
                                    parseInt(this.state.selectedTab) === parseInt(Selected_Index.i_One) &&
                                    <BillingComment
                                        financeAccountID={billingAccountId}
                                        isReadOnly={isReadOnly}
                                        isReadAndExtractOnly={isReadAndExtractOnly}
                                        isReadAndWrite={isReadAndWrite}
                                    />
                                }
                                {
                                    parseInt(this.state.selectedTab) === parseInt(Selected_Index.i_Two) &&
                                    <BillingHistory
                                        financeAccountID={this.state.billingAccountId}
                                        //Access Type
                                        isReadOnly={isReadOnly}
                                        isReadAndExtractOnly={isReadAndExtractOnly}
                                        isReadAndWrite={isReadAndWrite}
                                        isCreateNew={createNew}
                                    />
                                }

                            </DetailsLayout>
                            :
                            <DetailsDashboard
                                // Filter Properties
                                data={billingAccount.billingAccountItems.TableFilterData}
                                translation={""}
                                addAction={addBillingAccountFilter}
                                removeAction={removeBillingAccountFilter}
                                applyAction={this.applyFilter}
                                customClassName={"cost-allocation"}
                                //CreateNew Action
                                createNewAction={this.handleCreateNewAction}

                                //View Search Textbox
                                viewSearchAction={this.handleDisplaySearch}

                                //Customize Column
                                firstList={Available}
                                secondList={Selected}
                                defaultList={Default}
                                saveAction={saveBillingAccountCustomCols}

                                //Extract Button
                                extractAction={(e) => this.onClickExtract(e)}

                                //Access Type
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                            >
                                {
                                    billingAccount.isBillingAccountLoaded ?
                                        <TablePagination
                                            key={TABLE_PAGINATION_KEY.billingAccount}
                                            classNameWrapper="overflow-auto"
                                            columns={billingAccount.billingAccountItems.Headers}
                                            pageList={billingAccount.billingAccountItems.Data}
                                            pages={billingAccount.billingAccountItems.Pagination}
                                            rowClickAction={(value) => { this.getData(true, value) }}
                                            paginationAction={getBillingAccount}
                                            onColumnClick={sortBillingAccountList}
                                            onColumnSearch={() => getBillingAccount(0)}
                                            onColumnSearchChange={setBillingAccountColSearchStr}
                                            isColSearchShow={this.state.displaySearch}
                                            resizePage={this.resizePage}
                                            totalPage={billingAccount.billingAccountItems.Pagination.TotalEntries}
                                            hideStatusIcon={true}
                                        />
                                        :
                                        this.loadingScreen()
                                }
                            </ DetailsDashboard >
                    }
                </div>
            </div>
        )
    }
}

export default withRouter(connect(
    state => {
        const { billingAccount } = state;
        return {
            billingAccount
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, billingAccountActions),
        dispatch
    )
)(BillingAccount));
